import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/tuffexProductInventoryWorkspaceCapability/domain/TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type TuffexProductInventoryWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.tuffexProductInventory> & {
    fixedUdoTemplates: {
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.inventory]: {
            udoAdditionalColumnIds: {
                inventory: Uuid;
                ouId: Uuid;
                productCatalogueId: Uuid;
            };
        };
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.item]: {
            udoAdditionalColumnIds: {
                apiLogId: Uuid;
                availableInventory: Uuid;
                ouId: Uuid;
                plantId: Uuid;
                productCatalogueId: Uuid;
                source: Uuid;
                storageLocation: Uuid;
            };
        };
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.apiLog]: {
            udoAdditionalColumnIds: {
                error: Uuid;
                requestBody: Uuid;
                requestHeaders: Uuid;
                responseBody: Uuid;
                responseHeaders: Uuid;
                responseStatus: Uuid;
            };
        };
    };
};

export const tuffexProductInventoryWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.inventory]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                inventory: uuidZodValidator,
                ouId: uuidZodValidator,
                productCatalogueId: uuidZodValidator,
            }),
        }),
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.item]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                apiLogId: uuidZodValidator,
                availableInventory: uuidZodValidator,
                ouId: uuidZodValidator,
                plantId: uuidZodValidator,
                productCatalogueId: uuidZodValidator,
                source: uuidZodValidator,
                storageLocation: uuidZodValidator,
            }),
        }),
        [TuffexProductInventoryWorkspaceCapabilityUdoTemplateKey.apiLog]: zod.strictObject({
            udoTemplateId: uuidZodValidator,
            udoAdditionalColumnIds: zod.strictObject({
                error: uuidZodValidator,
                requestBody: uuidZodValidator,
                requestHeaders: uuidZodValidator,
                responseBody: uuidZodValidator,
                responseHeaders: uuidZodValidator,
                responseStatus: uuidZodValidator,
            }),
        }),
    }),
}) satisfies zod.ZodType<TuffexProductInventoryWorkspaceCapabilityUdoBindings>;
